<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { cloud_disabled_devices } from 'src/stores/device-runtime/firmware-ui';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		is_gen_2,
	} from 'src/helpers/interface_helpers';
	import { getDeviceAvatarDefaultConfig } from 'src/helpers/device_state_view_helpers';
	//Design System components
	import { Loader, ProgressBar, Text, CircleAvatar } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let isV2Component: boolean = false;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;

	$: calibrationProgress =
		status?.[get_gen_2_component_channel_structure(device)]?.calibration?.progress;
</script>

<CircleAvatar
	{...getDeviceAvatarDefaultConfig(device)}
	borderStatus={calibrationProgress >= 100
		? { icon: 'fa-solid fa-check', color: 'color-success' }
		: null}
/>

{#if is_gen_2(device) && device.category !== 'roller' && typeof $cloud_disabled_devices[device.id] === 'undefined'}
	<Text class="mb-s text-bold text-center"
		>{$format(deviceState?.description?.value)}</Text
	>
	<div class={isV2Component === true ? 'pl-m pr-m' : undefined}>
		<ProgressBar
			class="width-full mb-s"
			type={calibrationProgress > 100 ? 'success' : 'primary'}
			progress={calibrationProgress}
		/>
	</div>
	<Text class="text-color-muted text-center" styleType="body-small">
		{$format('progress_state_percent_complete', {
			default: `${calibrationProgress >= 100 ? 100 : calibrationProgress}% Complete`,
			values: {
				progress: calibrationProgress >= 100 ? 100 : calibrationProgress,
			},
		})}
	</Text>
{:else}
	<Text class="mb-s text-bold text-center">
		{$format(deviceState?.description?.value)}
	</Text>
	<Loader class="mb-s" />
{/if}
